import Vue from 'vue'

// 招考职位的三个组件
require('../views/zkzw/compos.js')
// 个人中心的三个组件
require('../views/grzx/compos.js')
//首页的注册弹窗
require('../views/sy/compos.js')



// WEBPACK FOOTER //
// ./src/utils/compos.js